/**
 * Custom Testimonial Template
 */

import { escapeHtml, createBlockWrapper, handleImageError } from '../utils';
import { applyThemeOverrides } from './utils';
import type { TemplateRenderer } from './types';

export const renderCustomTestimonial: TemplateRenderer = (
  config,
  data,
  container,
  _onAction,
  themeOverrides
) => {
  const title = config.title as string | undefined;
  const showRating = (config.showRating as boolean) ?? true;
  const showAvatar = (config.showAvatar as boolean) ?? true;

  const items = (data.items || data.testimonials || [data]) as Array<{
    quote: string;
    author: string;
    role?: string;
    company?: string;
    avatar?: string;
    rating?: number;
  }>;

  const wrapper = createBlockWrapper('custom-testimonial');
  applyThemeOverrides(wrapper, themeOverrides);

  if (title) {
    const titleEl = document.createElement('div');
    titleEl.className = 'pms-custom-testimonial-title';
    titleEl.textContent = title;
    wrapper.appendChild(titleEl);
  }

  const grid = document.createElement('div');
  grid.className = 'pms-custom-testimonial-grid';

  for (const item of items) {
    const card = document.createElement('div');
    card.className = 'pms-custom-testimonial-card';

    let html = '';

    // Rating stars
    if (showRating && item.rating) {
      const stars = '★'.repeat(item.rating) + '☆'.repeat(5 - item.rating);
      html += `<div class="pms-testimonial-rating">${stars}</div>`;
    }

    // Quote
    html += `<div class="pms-testimonial-quote">"${escapeHtml(item.quote)}"</div>`;

    // Author
    html += '<div class="pms-testimonial-author">';
    if (showAvatar && item.avatar) {
      html += `<img class="pms-testimonial-avatar" src="${escapeHtml(item.avatar)}" alt="" />`;
    }
    html += '<div class="pms-testimonial-author-info">';
    html += `<div class="pms-testimonial-name">${escapeHtml(item.author)}</div>`;
    if (item.role || item.company) {
      const subtitle = [item.role, item.company].filter(Boolean).join(', ');
      html += `<div class="pms-testimonial-role">${escapeHtml(subtitle)}</div>`;
    }
    html += '</div></div>';

    card.innerHTML = html;

    // Handle avatar error
    const avatar = card.querySelector('.pms-testimonial-avatar') as HTMLImageElement;
    if (avatar) handleImageError(avatar);

    grid.appendChild(card);
  }

  wrapper.appendChild(grid);
  container.appendChild(wrapper);
};
